// export const API_URL = "https://dev.iquoto.com:5006";
export const API_URL = "https://secure.iquoto.global:8080";

export const CLIENT_ADMIN_URL = "https://secure.iquoto.global";
export const WEBSITE_URL = "https://iquoto.global";

export const encryptionKey = "SigurnoNeZnas!";
